import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class OnEnterFigureTagEditing extends Plugin {
  init() {
    const editor = this.editor;
    const enterCommand = editor.commands.get( 'enter' );

    this.listenTo( enterCommand, 'afterExecute', ( evt, data ) => {
       const positionParent = editor.model.document.selection.getFirstPosition().parent;
       const positionParentClass = positionParent._attrs.get("class");

       if ( positionParent.is( 'element', 'figure' )  && (positionParentClass === 'image-class' || positionParentClass === 'audio-class' || positionParentClass === 'video-class') ){
           data.writer.rename( positionParent, 'paragraph' );
       }

       return;
    } );
 }
}
